<template>
  <div class="base-bulk-action-menu">
    <slot name="content"> </slot>
  </div>
</template>

<script>
export default {
  name: 'BaseBulkActionMenu',
  components: {},
  props: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.base-bulk-action-menu {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $color-white;
  border-radius: $border-radius-large;
  box-shadow: $shadow-dropdown, $shadow-default;
  font-size: $font-size-small;
  padding: 4px 16px 4px 54px;
  height: 52px;

  left: 20px;
  top: 16px;
  z-index: -1;

  @media screen and (min-width: 1200px) {
    left: 4px;
    top: 7px;
    z-index: -1;
  }
}
</style>
